import * as React from "react";
import * as ReactDOM from "react-dom";
// import * as jQuery from "jquery";
import {ISdata, IUploadImages, IEventWindow} from '../../../interfaces/models/IEvent';
import Ajax from '../../lib/Ajax';
import DateTool from '../../avernus/datetool/source/DateTool';
import { ReInitGallery } from "./Gallery";
import {IniteventEditHeaderImageComp, ReIniteventEditHeaderImage} from './EventEditHeaderImage';
import { ReInitSharedComp } from "./SharedCom";
import InvitateResponseBox from "./InvitateResponseBox";
import { Tools } from "../../lib/Tools";
import { InitComment } from "../../avernus/comment/source/Comment";

declare var _root:any;
declare var window:any;
declare var jQuery:any;


interface IEventEditProps {
    id:number
    isOwnEvent:boolean
}

interface IEventEditState {
    success:string
    error:string
    editMode:boolean
    item:ISdata
}

class EventEditComp extends React.Component<IEventEditProps, IEventEditState>{
    protected uploadeImages:Array<IUploadImages>;
    protected currentImages:Array<string>;
    protected htmlContent:string;
    private upload_dir:string

    constructor(props:IEventEditProps){
        super(props);
        this.init();
        // tslint:disable-next-line:no-unused-expression
        new InitComment(()=>{
            this.toggleComponent(this.state.editMode);
            document.getElementById('contentarea').classList.remove('hide');
        });
    }

    private init(){
        this.upload_dir = '/event/';
        var editMode:boolean = false;
        if ( window.location.href.indexOf('editMode') > -1 || window.location.href.indexOf('/new') > -1) {
            editMode = true;
        }

        this.state = {
            success: '',
            error: '',
            editMode: editMode,
            item: null
        };
        try{
            _root.initContentEditor();
        }catch(e){}
    }

    private getItem(editMode=false):void{
        if ( window.location.href.indexOf('editMode') > -1 || window.location.href.indexOf('/new') > -1 ) {
            editMode = true;
        }
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/event/get', 'POST', { id: this.props.id }, (data:ISdata) => {
            if ( this.props.id > 0 && data.error !== undefined ) {
                this.setState({
                    error: data.error,
                    editMode: editMode
                } as IEventEditState);
                document.getElementById("contentarea").parentNode.removeChild(document.getElementById("contentarea"));
                document.getElementById("bottom_btn_div").parentNode.removeChild(document.getElementById("bottom_btn_div"));
            }else{
                data.startTime  = data.startTime.toString().substr(0,5);
                data.endTime    = data.endTime.toString().substr(0,5);
                this.setState({
                    success : '',
                    error   : '',
                    item    : data,
                    editMode: editMode
                });
                // tslint:disable-next-line:no-unused-expression
                new ReIniteventEditHeaderImage(data.headerImage, editMode);
                // tslint:disable-next-line:no-unused-expression
                new ReInitSharedComp(data.sharedMode, data.sharedUserIds, data.invaitedUserIds, data.invaitedAndAcceptedUserIds, data.invaitedAndNotAcceptedUserIds, editMode);
                // tslint:disable-next-line:no-unused-expression
                new ReInitGallery(editMode);
            }
        });
    }

    private save(lastSave:boolean = false):void{
        var sData:any = this.state.item;
        sData.content = this.htmlContent;
        sData.lead = $(this.htmlContent).find('p:first').text();
        if ( $(this.htmlContent).find('img').length === 0 ) {
            sData.leadImage = '';
        }
        delete sData.userId;
        delete sData.insertedDate;
        delete sData.updatedDate;
        sData.draft = 0;
        if ( window.temp !== undefined && window.temp.smallFile !== undefined ) {
            sData.headerImage     = window.temp.smallFile;
        }
        if ( (window as IEventWindow).sharedMode !== undefined && (window as IEventWindow).sharedMode !== undefined ) {
            sData.sharedMode  = (window as IEventWindow).sharedMode;
        }
        if ( (window as IEventWindow).invaitedUserIds !== undefined && (window as IEventWindow).invaitedUserIds !== undefined ) {
            sData.invaitedUserIds  = (window as IEventWindow).invaitedUserIds;
        }
        if ( (window as IEventWindow).sharedUserIds !== undefined && (window as IEventWindow).sharedUserIds !== undefined ) {
            sData.sharedUserIds  = (window as IEventWindow).sharedUserIds;
        }
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/event/save', 'POST', sData , (data:any) => {
            if ( data.error !== undefined ) {
                this.setState({
                    success: '',
                    error : 'Hiba a mentés során!'
                } as IEventEditState);
            }else{
                if ( lastSave === true ) {
                    this.setState({
                        error: '',
                        success : 'Sikeres mentés!'
                    } as IEventEditState);
                    this.toggleComponent(this.state.editMode);
                    // tslint:disable-next-line:no-unused-expression
                    new ReInitGallery(this.state.editMode);
                }else{
                    this.getImages(this.htmlContent, data.userId, data.eventId);
                    var newItem             = this.state.item;
                    newItem.images          = this.uploadeImages;
                    newItem.currentImages   = this.currentImages;
                    newItem.headerImage     = data.headerImage;
                    this.setState({
                        item: newItem
                    } as IEventEditState, () =>{
                        this.save(true);
                    });
                }
            }
        });
    }

    private saveChangesHandler(evt): void {
        if ( evt !== undefined ) {
            evt.preventDefault();
        }
        if ( this.props.isOwnEvent === true ) {
             this.htmlContent = _root.getHtmlContent();
            this.save();
        }
    }

    private getImages(content:string, userId:number, eventId:number):void{
        this.uploadeImages = [];
        this.currentImages = [];
        var $content = jQuery('<placeholder>'+content+'</placeholder>');
		$content.find('img').each( (t, item) =>{
			this.addItemToUploadImages($(item).attr('src'), userId, eventId);
		});
    }

    private changeInputHandler(evt, fieldName:string): void {
        evt.preventDefault();
        var state = this.state;
        state.item[fieldName] = evt.target.value;
        this.setState(state);
    }

    protected addItemToUploadImages(src:string, userId:number, eventId:number){
        if ( src.indexOf('data:') > -1 ) {
            var new_file_name = this.imageHash(src);
            if ( new_file_name < 0 ) {
                new_file_name *= -1;
            }
            if ( src.indexOf('data:image/png') > -1 ) {
                new_file_name += '.png';
            }else if ( src.indexOf('data:image/gif') > -1 ) {
                new_file_name += '.gif';
            }else{
                new_file_name += '.jpg';
            }
            var path:string = '/uploads/user/' + userId   + this.upload_dir + eventId + '/'+new_file_name;
            this.uploadeImages.push({
                path: path,
                data: src.replace(/ /g, '')
            });
            if ( this.htmlContent.indexOf(src) > -1 ) {
                this.htmlContent = this.htmlContent.replace(src, path);
            }
        }else{
            this.currentImages.push(src);
        }
    }

    protected imageHash(str):any{
		var hash:any = 0, i, chr, len;
        if (str.length === 0){
            return hash;
        }
		for (i = 0, len = str.length; i < len; i++) {
			chr = str.charCodeAt(i);
			hash = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	}

    private toggleComponent(editMode):void{
        if ( editMode === true ) {
            if ( document.getElementById('save_btn_bar') !== null ) {
                document.getElementById('save_btn_bar').classList.remove('hide');
            }
            if ( document.getElementById('view_btn_bar') !== null ) {
                document.getElementById('view_btn_bar').classList.add('hide');
            }
            if ( document.getElementById('bottom_btn_div') !== null ) {
                document.getElementById('bottom_btn_div').classList.remove('hide');
            }
            if ( this.state.item !== null && this.state.item.id > 0 ) {
                document.getElementById('gallery_comp').classList.add('edit_mode');
            }
            // if ( document.getElementById('comment_comp') !== null ) {
                document.querySelector('.comment_comp').classList.add('hide');
                document.querySelector('#divCb').classList.remove('hide');
            // }
            document.querySelector('#contentarea').classList.remove('hide');
        }else{
            if ( document.getElementById('save_btn_bar') !== null ) {
                document.getElementById('save_btn_bar').classList.add('hide');
            }
            if ( document.getElementById('view_btn_bar') !== null ) {
                document.getElementById('view_btn_bar').classList.remove('hide');
            }
            if ( document.getElementById('bottom_btn_div') !== null ) {
                document.getElementById('bottom_btn_div').classList.add('hide');
                document.querySelector('#divCb').classList.add('hide');
                if ( document.querySelector('#contentarea:empty') !== null ) {
                    document.querySelector('#contentarea').classList.add('hide');
                }
            }
            document.getElementById('gallery_comp').classList.remove('edit_mode');
            // if ( document.getElementById('comment_comp') !== null ) {
                document.querySelector('.comment_comp').classList.remove('hide');
            // }
        }
    }

    private changeEditModeclickHandler(evt): void {
        evt.preventDefault();
        var newEditMode:boolean = !this.state.editMode;
        // tslint:disable-next-line:no-unused-expression
        new ReInitGallery(newEditMode);
        // tslint:disable-next-line:no-unused-expression
        new ReIniteventEditHeaderImage(this.state.item.headerImage, newEditMode);
        // tslint:disable-next-line:no-unused-expression
        new ReInitSharedComp(this.state.item.sharedMode, this.state.item.sharedUserIds, this.state.item.invaitedUserIds, this.state.item.invaitedAndAcceptedUserIds, this.state.item.invaitedAndNotAcceptedUserIds, newEditMode);
        this.toggleComponent(newEditMode);

        this.setState({
             editMode: newEditMode
        } as IEventEditState);
    }


    render() {
        if ( this.state.item === null && this.props.id > 0 && this.state.error === '' ) {
            this.getItem();
            return <div>
                Loading...
            </div>
        }
        if ( this.state.editMode === true ) {
            setTimeout(()=>{
                jQuery('[data-toggle="datepicker"]').datepicker({
                    // format: 'yyyy.mm.dd.',
                    language: 'hu-HU'
                });
                jQuery('[data-toggle="datepicker"]').on('pick.datepicker',  (evt) => {
                    setTimeout(()=>{
                        var input:HTMLInputElement = evt.target as HTMLInputElement;
                        var state = this.state;
                        var newValue:string = input.value.substr(0,input.value.length-1).replace(/\./g,'-');
                        if ( evt.target.id === 'start_date' ) {
                            state.item.startDate = newValue;
                        }else if ( evt.target.id === 'end_date' ) {
                            state.item.endDate = newValue;
                        }
                        this.setState(state);
                    }, 100);
                    document.querySelector('.datepicker-container').classList.toggle('datepicker-hide');
                });
            }, 100);
        }else{
            if ( this.state.error !== '' ) {
                return(<div className="event_view">
                    <div>
                        <div className="alert danger">
                            {this.state.error }
                        </div>
                    </div>
                </div>);
            }
            return(
                <div className="event_view mrgt10">
                    { this.props.isOwnEvent === true?<div>
                        <div className="row">
                            <button onClick={ (e) => { this.changeEditModeclickHandler(e); } } className="btn" id="change_to_edit_btn">
                                Esemény Szerkesztés
                            </button>
                        </div>
                    </div>:<div>
                        { this.state.item.invited === true?<InvitateResponseBox eventId={ this.state.item.id } status={this.state.item.invitedStatus} />:'' }
                    </div> }

                    <div className="row mrgt10">
                        <div className="box">
                            <a href={ '/profilok/'+this.state.item.userId } target="_blank">
                                <img src={ this.state.item.ownerImage.replace('.jpg','_small.jpg') } alt="" />
                            </a>
                        </div>
                        <div className="box">
                            <a href="#">
                                <h3>
                                    { this.state.item.name }
                                </h3>
                            </a>
                            <div className="desc">
                                <div className="address_row">
                                    <span>
                                        Helyszín:
                                    </span> { this.state.item.address }
                                </div>
                                <div className="time_row">
                                    <span>
                                        Időpont:
                                    </span> { Tools.dateTimeDistanceFormatter(this.state.item) }
                                </div>
                                <div className="owner_row">
                                    <span>
                                        Szervező:
                                    </span> <a href={ '/profilok/'+this.state.item.userId } className="owner" target="_blank">
                                        { this.state.item.ownerName }
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <form id="event_form" className="event_from" onSubmit={ e => this.saveChangesHandler(e) }>
                    { this.state.success !== ''?<div className="alert success">
                        {this.state.success }
                    </div>:'' }
                    { this.state.error !== ''?<div className="alert danger">
                        {this.state.error }
                    </div>:'' }
                    <div className="row mt10">
                        <div className="box" style={{display:'none'}}>
                                <button type="submit" className="btn" id="event_save_btn">
                                    Mentés
                                </button>
                                { this.state.item.id !== 0 ?<button onClick={ (e) => { this.changeEditModeclickHandler(e); } } id="preview_btn" className="btn preview_btn">
                                    Előnézet
                                </button>:'' }

                            <br />
                            <br />
                        </div>
                        <div className="row">
                            <div className="box">
                                <label htmlFor="name">
                                    Megnevezés
                                </label>
                            </div>
                            <div className="box">
                                <input type="text" id="name" required={true}  onChange={ e => this.changeInputHandler(e, 'name') } value={
                                    this.state.item.name
                                } />
                            </div>
                        </div>

                        <div className="row">
                            <div className="box">
                                <label htmlFor="start_date">
                                    Kezdés
                                </label>
                            </div>
                            <div className="box">
                                <input type="text" className="date_picker_width" id="start_date" data-toggle="datepicker" onChange={ e => this.changeInputHandler(e, 'startDate') } value={
                                    DateTool.getDateHu(this.state.item.startDate) + '.'
                                } />
                                <input type="text" className="time_picker_width" onChange={ e => this.changeInputHandler(e, 'startTime') } value={ this.state.item.startTime } pattern="[0-9][0-9]\:[0-9][0-9]$" title="Hibás idő formátum!" maxLength={5} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="box">
                                <label htmlFor="end_date">
                                    Vége
                                </label>
                            </div>
                            <div className="box">
                                <input type="text" className="date_picker_width" id="end_date" data-toggle="datepicker" onChange={ e => this.changeInputHandler(e, 'endDate') } value={
                                    DateTool.getDateHu(this.state.item.endDate) + '.'
                                } />
                                <input type="text" className="time_picker_width" onChange={ e => this.changeInputHandler(e, 'endTime') } value={ this.state.item.endTime } pattern="[0-9][0-9]\:[0-9][0-9]$" title="Hibás idő formátum!" maxLength={5} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="box">
                                <label htmlFor="address">
                                    Helyszín vagy cím
                                </label>
                            </div>
                            <div className="box">
                                <input type="text" id="address" onChange={ e => this.changeInputHandler(e, 'address') } value={
                                    this.state.item.address
                                } />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default class InitEventEditComp {
    constructor() {
        var div: HTMLDivElement = document.getElementById('even_edit_component') as HTMLDivElement;
        if (div !== null) {
            var data = div.dataset;
            var id:number = parseInt(data.id);
            var isOwnEvent:boolean = data.isownevent === 'true'? true:false;
            ReactDOM.render(< EventEditComp id={id} isOwnEvent={isOwnEvent} />, div, ()=>{
                if ( isOwnEvent === true) {
                    var bottomBtnDiv:HTMLDivElement = document.createElement('div');
                    bottomBtnDiv.id                 = "bottom_btn_div";
                    bottomBtnDiv.className          = 'hide';
                    // bottomBtnDiv.innerHTML          = '<br /><div class="row"><div class="box"><a class="btn" onClick="document.getElementById(\'event_save_btn\').click();">Mentés</a></div></div>';
                    document.getElementById('contentarea').parentNode.appendChild(bottomBtnDiv);
                    document.querySelector('.right_box #save_btn_bar').innerHTML = '<div class=""><a class="btn red" onClick="document.getElementById(\'event_save_btn\').click();">Mentés</a><a class="btn" onClick="document.getElementById(\'preview_btn\').click();">Előnézet</a></div>';
                    document.querySelector('.right_box #view_btn_bar').innerHTML = '<div class=""><a class="btn red" onClick="document.getElementById(\'change_to_edit_btn\').click();">Esemény Szerkesztése</a></div>';
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./components/event/EventEdit.tsx